<template>
  <div class="main_box">
    <!-- <div class="blue_box flex main_hot">
      <div class="hot_box">Frequent Q&A</div>
      <div class="hot_list">
        <router-link :to="{ path: '/contact' }"><span><i>01</i>Hot Issues</span></router-link>
        <router-link :to="{ path: '/contact' }"><span><i>02</i>Hot Issues</span></router-link>
        <router-link :to="{ path: '/contact' }"><span><i>03</i>Hot Issues</span></router-link>
      </div>
    </div> -->
    <div>
      <div class="small_title">
        {{ $t('enum.summary') }}
        <router-link class="over_btn" :to="{ path: '/commodity/New' }">+ {{ $t('button.addNewItem') }}</router-link>
      </div>
      <div class="flex_layout_between summary">
        <div class="summary_f">
          <div class="blue_box">
            <router-link class="summary_box" :to="{ path: '/commodity/Active/Auction' }">
              <div class="blue_img active">
              </div>
              <div class="blue_txt">
                <div>{{ $t('enum.active') }}</div>
                <div><span>{{ CommodityStatis.ActiveCount ? CommodityStatis.ActiveCount : 0 }}</span> {{ CommodityStatis.ActiveCount != 1 ? $t('enum.items') : $t('enum.item') }}</div>
              </div>
            </router-link>
          </div>
          <div class="blue_box">
            <router-link class="summary_box" :to="{ path: '/commodity/Scheduled' }">
              <div class="blue_img scheduled">
              </div>
              <div class="blue_txt">
                <div>{{ $t('enum.scheduled') }}</div>
                <div><span>{{ CommodityStatis.ScheduledCount ? CommodityStatis.ScheduledCount : 0 }}</span> {{ CommodityStatis.ScheduledCount != 1 ? $t('enum.items') : $t('enum.item') }}</div>
              </div>
            </router-link>
          </div>
        </div>

        <div class="summary_f">
          <div class="blue_box">
            <router-link class="summary_box" :to="{ path: '/commodity/Unsold' }">
              <div class="blue_img unsold">
              </div>
              <div class="blue_txt">
                <div>{{ $t('enum.unsold') }}</div>
                <div><span>{{ CommodityStatis.UnsoldCount ? CommodityStatis.UnsoldCount : 0 }}</span> {{ CommodityStatis.UnsoldCount != 1 ? $t('enum.items') : $t('enum.item') }}</div>
              </div>
            </router-link>
          </div>
          <div class="blue_box">
            <router-link class="summary_box" :to="{ path: '/commodity/Draft' }">
              <div class="blue_img draft">
              </div>
              <div class="blue_txt">
                <div>{{ $t('enum.draft') }}</div>
                <div><span>{{ CommodityStatis.DraftCount ? CommodityStatis.DraftCount : 0 }}</span> {{ CommodityStatis.DraftCount != 1 ? $t('enum.items') : $t('enum.item') }}</div>
              </div>
            </router-link>
          </div>
        </div>

      </div>
    </div>
    <div class="flex_layout_between">
      <div class="info_box">
        <div class="small_title">{{ $t('enum.toDoList') }}</div>
        <div class="flex_layout_between blue_box">
          <router-link class="summary_box" :to="{ name: 'orders', params: { sellOrderType: 2 } }">
            <div class="todo_box">
              <div class="blue_img shipping">
                <span></span>
              </div>
              <div class="blue_txt">
                <div class="Overview_p">{{ $t('enum.toBeShipped') }}</div>
                <div>
                  <span class="text_red">{{ OrderStatis.ShippingCount ? OrderStatis.ShippingCount : 0 }}</span>
                  <i>{{ OrderStatis.ShippingTime ? endingTime(OrderStatis.ShippingTime) : '' }}</i>
                </div>
              </div>
            </div>
          </router-link>
          <router-link class="summary_box" :to="{ name: 'commodity-Offer', params: { type: 2 } }">
            <div class="todo_box first_todo_box">
              <div class="blue_img answerd">
                <span></span>
              </div>
              <div class="blue_txt">
                <div class="Overview_p">{{ $t('enum.offersToReply') }}</div>
                <div>
                  <span class="text_red">{{ OrderStatis.AnswerdCount ? OrderStatis.AnswerdCount : 0 }}</span>
                  <!-- <i>{{OrderStatis.AnswerdDate?OrderStatis.AnswerdDate:''}}</i> -->
                  <i v-if="OrderStatis.AnswerdCount > 0">{{ OrderStatis.AnswerdTime ? endingTime(OrderStatis.AnswerdTime) : '' }}</i>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="info_box">
        <div class="small_title">{{ $t('enum.storeData') }}</div>
        <div class="flex_layout_between blue_box">
          <router-link class="summary_box" :to="{ path: '/store' }">
            <div class="summary_box">
              <div class="todo_box two_todo_box">
                <div class="blue_img followers">
                  <span></span>
                </div>
                <div class="blue_txt">
                  <div class="Overview_p">{{ $t('enum.followers') }}</div>
                  <div>
                    <span class="">{{ StoreStatis.AttentionCount ? StoreStatis.AttentionCount : 0 }}</span>
                    {{ StoreStatis.AttentionCount != 1 ? $t('enum.followers') : $t('enum.follower') }}
                  </div>
                </div>
              </div>
            </div>
          </router-link>
          <router-link class="summary_box" :to="{ path: '/store' }">
            <div class="summary_box">
              <div class="todo_box last_todo_box">
                <div class="blue_img rate">
                  <span></span>
                </div>
                <div class="blue_txt">
                  <div class="Overview_p">{{ $t('enum.positive') }}</div>
                  <div>
                    <span class="">{{ StoreStatis.Favorable ? StoreStatis.Favorable : 0 }}</span>
                    %
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <div v-if="haveWallet">
      <div class="small_title">
        {{ $t("enum.storeAccount") }}
      </div>
      <div class="flex_layout_between">
        <div class="summary_f" style="width: 100%;">
          <div class="blue_box" style="width: 49%">
            <router-link class="summary_box" :to="{ path: '/wallet' }">
              <div style="display: flex;width: 50%;">
                <div class="blue_img account">
                  <span></span>
                </div>
                <div class="blue_txt">
                  <div class="Overview_p">{{ $t("enum.accountBalance") }}</div>
                  <div style="color: #5F6DAE;display: flex;align-items: baseline;">
                    <div style="color: #333;">{{ walletInfo.Currency }}</div>
                    <span style="margin-left: 8px;margin-right: 0;">
                      {{ balance1 }}
                    </span>{{ balance2 ? '.' + balance2 : '' }}
                  </div>
                </div>
              </div>

              <div class="account_side">
                <div class="account_btn">{{ $t("button.withdraw") }}</div>
              </div>
            </router-link>
          </div>
        </div>
      </div>

    </div>


    <div class="flex_layout_between">
      <div class="small_title">{{ $t('enum.orderData') }}</div>
      <div class="home_select">
        <el-select class="select_box select_times" @change="changeTime" v-model="times">
          <el-option v-for="item in all_times" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-select class="select_box" @change="changeSales" v-model="sales">
          <el-option v-for="item in all_sales" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
    </div>
    <home-chart ref="OrderChart" />
  </div>
</template>

<script>
import HomeChart from '@/components/chart'

export default {
  name: '',
  components: { HomeChart },
  data() {
    return {
      timer: "",
      nowData: new Date().getTime(),
      times: "7 " + this.$t('enum.days'),
      all_times: [{ value: 7, label: "7 " + this.$t('enum.days') }, { value: 30, label: "30 " + this.$t('enum.days') }],
      sales: this.$t('enum.salesVolume'),
      all_sales: [{ value: 'SalesVolume', label: this.$t('enum.salesVolume') }, { value: "Sales", label: this.$t('enum.sales') }],
      CommodityStatis: {},
      OrderStatis: {},
      StoreStatis: {},
      walletInfo: {},//钱包相关信息
      balance1: '',
      balance2: '',
      Chart: [],
      xAxis: [],
      yAxis: [],
      yPriceVal: [],
      yOCountVal: [],
      startTime: "",//开始时间
      endTime: "",//结束时间
      testData: [{ "SellUserID": 281006, "OrdersCount": 1, "StatisticalDate": "2023-06-05 00:00:00", "TotalPriceCNY": 92.63, "TotalPriceUSD": 13.02, "_id": "4730486860711060268", "CreateUser": "system", "CreateDate": "2023-06-06 05:00:55", "LastUpdateUser": "system", "LastUpdateDate": "2023-06-06 05:00:55" }, { "SellUserID": 281006, "OrdersCount": 1, "StatisticalDate": "2023-06-05 00:00:00", "TotalPriceCNY": 92.63, "TotalPriceUSD": 13.02, "_id": "4730486860711060268", "CreateUser": "system", "CreateDate": "2023-06-06 05:00:55", "LastUpdateUser": "system", "LastUpdateDate": "2023-06-06 05:00:55" }, { "SellUserID": 281006, "OrdersCount": 1, "StatisticalDate": "2023-06-05 00:00:00", "TotalPriceCNY": 92.63, "TotalPriceUSD": 13.02, "_id": "4730486860711060268", "CreateUser": "system", "CreateDate": "2023-06-06 05:00:55", "LastUpdateUser": "system", "LastUpdateDate": "2023-06-06 05:00:55" }, { "SellUserID": 281006, "OrdersCount": 1, "StatisticalDate": "2023-06-05 00:00:00", "TotalPriceCNY": 92.63, "TotalPriceUSD": 13.02, "_id": "4730486860711060268", "CreateUser": "system", "CreateDate": "2023-06-06 05:00:55", "LastUpdateUser": "system", "LastUpdateDate": "2023-06-06 05:00:55" }, { "SellUserID": 281006, "OrdersCount": 1, "StatisticalDate": "2023-06-05 00:00:00", "TotalPriceCNY": 92.63, "TotalPriceUSD": 13.02, "_id": "4730486860711060268", "CreateUser": "system", "CreateDate": "2023-06-06 05:00:55", "LastUpdateUser": "system", "LastUpdateDate": "2023-06-06 05:00:55" }, { "SellUserID": 281006, "OrdersCount": 1, "StatisticalDate": "2023-06-05 00:00:00", "TotalPriceCNY": 92.63, "TotalPriceUSD": 13.02, "_id": "4730486860711060268", "CreateUser": "system", "CreateDate": "2023-06-06 05:00:55", "LastUpdateUser": "system", "LastUpdateDate": "2023-06-06 05:00:55" }, { "SellUserID": 281006, "OrdersCount": 1, "StatisticalDate": "2023-06-05 00:00:00", "TotalPriceCNY": 92.63, "TotalPriceUSD": 13.02, "_id": "4730486860711060268", "CreateUser": "system", "CreateDate": "2023-06-06 05:00:55", "LastUpdateUser": "system", "LastUpdateDate": "2023-06-06 05:00:55" }, { "SellUserID": 281006, "OrdersCount": 1, "StatisticalDate": "2023-06-05 00:00:00", "TotalPriceCNY": 92.63, "TotalPriceUSD": 13.02, "_id": "4730486860711060268", "CreateUser": "system", "CreateDate": "2023-06-06 05:00:55", "LastUpdateUser": "system", "LastUpdateDate": "2023-06-06 05:00:55" }, { "SellUserID": 281006, "OrdersCount": 1, "StatisticalDate": "2023-06-05 00:00:00", "TotalPriceCNY": 92.63, "TotalPriceUSD": 13.02, "_id": "4730486860711060268", "CreateUser": "system", "CreateDate": "2023-06-06 05:00:55", "LastUpdateUser": "system", "LastUpdateDate": "2023-06-06 05:00:55" }, { "SellUserID": 281006, "OrdersCount": 1, "StatisticalDate": "2023-06-05 00:00:00", "TotalPriceCNY": 92.63, "TotalPriceUSD": 13.02, "_id": "4730486860711060268", "CreateUser": "system", "CreateDate": "2023-06-06 05:00:55", "LastUpdateUser": "system", "LastUpdateDate": "2023-06-06 05:00:55" }, { "SellUserID": 281006, "OrdersCount": 1, "StatisticalDate": "2023-06-05 00:00:00", "TotalPriceCNY": 92.63, "TotalPriceUSD": 13.02, "_id": "4730486860711060268", "CreateUser": "system", "CreateDate": "2023-06-06 05:00:55", "LastUpdateUser": "system", "LastUpdateDate": "2023-06-06 05:00:55" }, { "SellUserID": 281006, "OrdersCount": 1, "StatisticalDate": "2023-06-05 00:00:00", "TotalPriceCNY": 92.63, "TotalPriceUSD": 13.02, "_id": "4730486860711060268", "CreateUser": "system", "CreateDate": "2023-06-06 05:00:55", "LastUpdateUser": "system", "LastUpdateDate": "2023-06-06 05:00:55" }, { "SellUserID": 281006, "OrdersCount": 1, "StatisticalDate": "2023-06-05 00:00:00", "TotalPriceCNY": 92.63, "TotalPriceUSD": 13.02, "_id": "4730486860711060268", "CreateUser": "system", "CreateDate": "2023-06-06 05:00:55", "LastUpdateUser": "system", "LastUpdateDate": "2023-06-06 05:00:55" }, { "SellUserID": 281006, "OrdersCount": 1, "StatisticalDate": "2023-06-04 00:00:00", "TotalPriceCNY": 14.05, "TotalPriceUSD": 1.97, "_id": "5705227210061906395", "CreateUser": "system", "CreateDate": "2023-06-05 05:01:11", "LastUpdateUser": "system", "LastUpdateDate": "2023-06-05 05:01:11" }, { "SellUserID": 281006, "OrdersCount": 3, "StatisticalDate": "2023-05-30 00:00:00", "TotalPriceCNY": 545.6, "TotalPriceUSD": 77.15, "_id": "4793685040937393328", "CreateUser": "system", "CreateDate": "2023-05-31 05:01:02", "LastUpdateUser": "system", "LastUpdateDate": "2023-05-31 05:01:02" }, { "SellUserID": 281006, "OrdersCount": 12, "StatisticalDate": "2023-05-29 00:00:00", "TotalPriceCNY": 2529.84, "TotalPriceUSD": 357.69, "_id": "4836818773127724137", "CreateUser": "system", "CreateDate": "2023-05-30 05:01:02", "LastUpdateUser": "system", "LastUpdateDate": "2023-05-30 05:01:02" }, { "SellUserID": 281006, "OrdersCount": 5, "StatisticalDate": "2023-05-28 00:00:00", "TotalPriceCNY": 5714.27, "TotalPriceUSD": 807.06, "_id": "5473597663172426676", "CreateUser": "system", "CreateDate": "2023-05-29 05:01:04", "LastUpdateUser": "system", "LastUpdateDate": "2023-05-29 05:01:04" }, { "SellUserID": 281006, "OrdersCount": 6, "StatisticalDate": "2023-05-27 00:00:00", "TotalPriceCNY": 2243.64, "TotalPriceUSD": 317.23, "_id": "4632512882726779084", "CreateUser": "system", "CreateDate": "2023-05-28 05:00:58", "LastUpdateUser": "system", "LastUpdateDate": "2023-05-28 05:00:58" }, { "SellUserID": 281006, "OrdersCount": 10, "StatisticalDate": "2023-05-26 00:00:00", "TotalPriceCNY": 980.42, "TotalPriceUSD": 138.73, "_id": "5223286247513096050", "CreateUser": "system", "CreateDate": "2023-05-27 05:01:00", "LastUpdateUser": "system", "LastUpdateDate": "2023-05-27 05:01:00" }, { "SellUserID": 281006, "OrdersCount": 5, "StatisticalDate": "2023-05-25 00:00:00", "TotalPriceCNY": 1130.8, "TotalPriceUSD": 161.48, "_id": "5671522141942206369", "CreateUser": "system", "CreateDate": "2023-05-26 05:00:53", "LastUpdateUser": "system", "LastUpdateDate": "2023-05-26 05:00:53" }, { "SellUserID": 281006, "OrdersCount": 6, "StatisticalDate": "2023-05-24 00:00:00", "TotalPriceCNY": 580.54, "TotalPriceUSD": 82.44, "_id": "5642645702875890657", "CreateUser": "system", "CreateDate": "2023-05-25 05:00:59", "LastUpdateUser": "system", "LastUpdateDate": "2023-05-25 05:00:59" }, { "SellUserID": 281006, "OrdersCount": 1, "StatisticalDate": "2023-05-23 00:00:00", "TotalPriceCNY": 948.14, "TotalPriceUSD": 134.64, "_id": "5141982353486292781", "CreateUser": "system", "CreateDate": "2023-05-24 05:00:55", "LastUpdateUser": "system", "LastUpdateDate": "2023-05-24 05:00:55" }, { "SellUserID": 281006, "OrdersCount": 13, "StatisticalDate": "2023-05-19 00:00:00", "TotalPriceCNY": 177.76, "TotalPriceUSD": 25.36, "_id": "5166039416147352082", "CreateUser": "system", "CreateDate": "2023-05-20 05:00:51", "LastUpdateUser": "system", "LastUpdateDate": "2023-05-20 05:00:51" }, { "SellUserID": 281006, "OrdersCount": 1, "StatisticalDate": "2023-05-17 00:00:00", "TotalPriceCNY": 6.87, "TotalPriceUSD": 0.99, "_id": "5639321012493973319", "CreateUser": "system", "CreateDate": "2023-05-18 05:00:51", "LastUpdateUser": "system", "LastUpdateDate": "2023-05-18 05:00:51" }, { "SellUserID": 281006, "OrdersCount": 2, "StatisticalDate": "2023-05-16 00:00:00", "TotalPriceCNY": 153.57, "TotalPriceUSD": 22.02, "_id": "5260887475220919376", "CreateUser": "system", "CreateDate": "2023-05-17 05:00:52", "LastUpdateUser": "system", "LastUpdateDate": "2023-05-17 05:00:52" }, { "SellUserID": 281006, "OrdersCount": 3, "StatisticalDate": "2023-05-15 00:00:00", "TotalPriceCNY": 25.6, "TotalPriceUSD": 3.67, "_id": "5295501171449218821", "CreateUser": "system", "CreateDate": "2023-05-16 05:01:01", "LastUpdateUser": "system", "LastUpdateDate": "2023-05-16 05:01:01" }, { "SellUserID": 281006, "OrdersCount": 1, "StatisticalDate": "2023-05-12 00:00:00", "TotalPriceCNY": 410.06, "TotalPriceUSD": 59.09, "_id": "5198858068061584872", "CreateUser": "system", "CreateDate": "2023-05-15 15:25:13", "LastUpdateUser": "system", "LastUpdateDate": "2023-05-15 15:25:13" }, { "SellUserID": 281006, "OrdersCount": 4, "StatisticalDate": "2023-05-11 00:00:00", "TotalPriceCNY": 702.71, "TotalPriceUSD": 101.28, "_id": "4710279845809520015", "CreateUser": "system", "CreateDate": "2023-05-15 15:24:24", "LastUpdateUser": "system", "LastUpdateDate": "2023-05-15 15:24:24" }, { "SellUserID": 281006, "OrdersCount": 21, "StatisticalDate": "2023-05-10 00:00:00", "TotalPriceCNY": 6146.09, "TotalPriceUSD": 886.1, "_id": "5281273066635703776", "CreateUser": "system", "CreateDate": "2023-05-15 15:23:43", "LastUpdateUser": "system", "LastUpdateDate": "2023-05-15 15:23:43" }, { "SellUserID": 281006, "OrdersCount": 4, "StatisticalDate": "2023-05-09 00:00:00", "TotalPriceCNY": 80.54, "TotalPriceUSD": 11.62, "_id": "5637409351032744391", "CreateUser": "system", "CreateDate": "2023-05-15 15:22:56", "LastUpdateUser": "system", "LastUpdateDate": "2023-05-15 15:22:56" }]
    }
  },
  computed: {
    haveWallet() {
      let AccountId = this.$store.state.UserInfo.AccountId;
      let MemberSource = this.$store.state.UserInfo.MemberSource;
      let Wallet = MemberSource != 'US' && (AccountId && AccountId.indexOf('payee_') > -1) ? true : false;
      return Wallet;
    }
  },
  created() {
    this.cardTimer();
  },
  mounted() {
    var that = this;
    that.getData('GetCommodityStatistics');
    that.getData('GetOrderStatistics');
    that.getData('GetStoreStatistics');
    var haveWallet = that.haveWallet;
    // console.log(haveWallet, 'haveWallet');
    if (haveWallet) {
      that.GetAccountInfo();
    }
    that.getSEtime()//默认获取7Days
    // this.aaa=this.$store.getters.MathRound(0.1351)
    // let value="dfsg dfas"
    // if (!/^[^[\u4E00-\u9FA5]+$/.test(value) && value) {
    //   console.log("不能输入汉字");
    // }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    getData(api, params) {
      var that = this;
      that.$get(api, params).then((res) => {
        if (res.result) {
          switch (api) {
            case "GetCommodityStatistics":
              that.CommodityStatis = res.data;
              break;
            case "GetOrderStatistics":
              that.OrderStatis = res.data;
              break;
            case "GetStoreStatistics":
              that.StoreStatis = res.data;
              break;
            case "GetSellerDaySales":
              let _data = res.data;
              let xAxis = [], yPriceVal = [], yOCountVal = [];
              that.Chart = _data;
              // console.log("that.testData", that.testData);
              that.xAxis = xAxis;
              if (_data && _data.length) {
                _data.map((obj, k) => {
                  let _date = obj['StatisticalDate'].split(" ")[0];
                  let lang = this.$store.state.lang;
                  if (lang && lang.indexOf("zh") > -1) {
                    //zh_ 北京时间
                    _date = that.$store.getters.getTime(_date, 8, "cmtNull", "YYYY-MM-DD");
                  } else {//EN
                    _date = that.$store.getters.getTime(_date, -8, "cmtNull", "MMM DD, YYYY");
                  }

                  xAxis.push(_date);
                  yPriceVal.push(obj['TotalPriceUSD']);
                  yOCountVal.push(obj['OrdersCount']);
                });
                that.$refs.OrderChart.xAxis = xAxis;
                // that.$refs.OrderChart.yAxis = yOCountVal;
              } else {
                that.$refs.OrderChart.xAxis = ['No Data'];
                // that.$refs.OrderChart.yAxis = [100];
              }
              // that.$refs.OrderChart.yType = "SalesVolume";
              // that.$refs.OrderChart.chartType = "Sales Volume";
              that.yPriceVal = yPriceVal;
              that.yOCountVal = yOCountVal;
              that.changeSales(that.sales)
              // console.log("GetSellerDaySales", res)
              break;
          }
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    GetAccountInfo() {
      var that = this
      that.$post('GetAccountInfo', {
        MemberId: that.$store.state.UserInfo.MappingUserId
      }, 'WalletApi')
        .then((res) => {
          // that.walletLoading = false;
          if (res.Result && res.Data) {
            that.walletInfo = res.Data;
            // var _maxStateDate = res.data.MaxStartDate;
            // that.maxStateDate = _maxStateDate;
            // that.$refs.WDatePicker.maxStateDate = _maxStateDate;
            that.ThousandAndDecimal(res.Data.AvailableAmount)
            // console.log("walletInfo", that.walletInfo)
          } else {
            // that.$message.error('Login failed');
          }
        })
        .catch((err) => {
          console.log(err);
        });

    },
    ThousandAndDecimal(num) {
      //金额千分位
      var val = "";
      if (num && parseFloat(num) > 0) {
        val = parseFloat(num).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        this.balance1 = val.split('.')[0]
        this.balance2 = val.split('.')[1]
      } else {
        this.balance1 = '0'
        this.balance2 = ''
      }
    },
    changeTime(e) {
      // console.log("changeTime", e);
      this.getSEtime(e);
    },
    changeSales(e) {
      var that = this;
      // console.log("changeSales", e);
      if (e == 'Sales') {
        that.$refs.OrderChart.yType = "Sales";
        that.$refs.OrderChart.chartType = this.$t('enum.sales');
        that.$refs.OrderChart.yAxis = that.yPriceVal.length ? that.yPriceVal : [100];
      } else {
        that.$refs.OrderChart.yType = "SalesVolume";
        that.$refs.OrderChart.chartType = this.$t('enum.salesVolume');
        that.$refs.OrderChart.yAxis = that.yOCountVal.length ? that.yOCountVal : [100];
      }
    },
    getSEtime(e) {
      var that = this;
      //获取时间
      if (!e) { e = 7 }
      //开始时间
      let startTime = that.$store.getters.timeCount(new Date(), e, 'd');
      startTime = that.$store.getters.getTime(
        startTime,
        8,
        "cmtNull",
        "YYYY-MM-DD"
      );
      //结束时间
      let endTime = that.$store.getters.timeCount(new Date(), 1, 'd');
      endTime = that.$store.getters.getTime(
        endTime,
        8,
        "cmtNull",
        "YYYY-MM-DD"
      );
      that.startTime = startTime;
      that.endTime = endTime;
      console.log(that.startTime, "~", that.endTime)
      that.getData('GetSellerDaySales', `?StartDate=${startTime}&EndDate=${endTime}&PageSize=999&PageIndex=1`);//卖家日销售统计
    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },
    endingTime(time) {
      let newval = this.$store.getters.setUTC(this.nowData, -8)
      return this.$store.getters.endingTime(newval, '', '', time)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/overview.css";
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue